var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9412,
    cy: 26,
    r: 25.5,
    fill: "#4987FF",
    stroke: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1037 24.0976C27.1292 23.0498 28.4644 22.3643 30.0177 22.3643C31.6489 22.3643 33.2133 23.0123 34.3668 24.1657C35.5202 25.3192 36.1682 26.8836 36.1682 28.5148V36.9019H33.9317V28.5148C33.9317 27.4768 33.5193 26.4812 32.7853 25.7472C32.0513 25.0132 31.0557 24.6008 30.0177 24.6008C28.9796 24.6008 27.9841 25.0132 27.2501 25.7472C26.5161 26.4812 26.1037 27.4768 26.1037 28.5148V36.9019H23.8671V22.9234H26.1037V24.0976ZM18.2757 20.6869C17.8309 20.6869 17.4042 20.5101 17.0896 20.1956C16.7751 19.881 16.5983 19.4543 16.5983 19.0095C16.5983 18.5646 16.7751 18.1379 17.0896 17.8233C17.4042 17.5088 17.8309 17.332 18.2757 17.332C18.7206 17.332 19.1473 17.5088 19.4619 17.8233C19.7764 18.1379 19.9532 18.5646 19.9532 19.0095C19.9532 19.4543 19.7764 19.881 19.4619 20.1956C19.1473 20.5101 18.7206 20.6869 18.2757 20.6869ZM17.1575 22.9234H19.394V36.9019H17.1575V22.9234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertL);
export default __webpack_public_path__ + "static/media/Expert_l.a7d51c8a646922107b1830bf28150c08.svg";
export { ForwardRef as ReactComponent };